import { useEffect, useState } from 'react';

export const DEFAULT_DEBOUNCE_MS = 400;

export const useDebouncedValue = <T>(value: T, delayMs: number = DEFAULT_DEBOUNCE_MS): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => setDebouncedValue(value), delayMs);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [value, delayMs]);

  return debouncedValue;
};
